module.exports = __webpack_public_path__ + "img/ai.a51a57c3.svg";